module.exports = __webpack_public_path__ + "static/half-section-with-pattern-0d56600b949299524e788751db4b6660.png";